<script lang="ts">
  import type { FacetValueGroup, FacetValueGroupOptions } from "./type";
  import Box from "./Box.svelte";

  interface Props extends FacetValueGroup, FacetValueGroupOptions {}

  let { values = [], title, item, containsRanges, valueStatus }: Props = $props();
</script>

<Box {values} {title} {valueStatus} {item} {containsRanges} wrap={false} />
